import styled from 'styled-components';
export const List = styled.ul `
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  li {
    display: flex;
    padding: 0 1rem 1rem;
    img {
      display: block;
      margin: auto;
    }
  }
  ${({ justified }) => justified
    ? `
        justify-content: space-between;
        margin: 0 -1rem; 
        padding: 1rem 0;
      `
    : `
        justify-content: center;
        margin: 0;
        padding: 1rem;
    `}
`;
//# sourceMappingURL=UiImageSet.styles.js.map